import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage, transformResponse } from "../baseQuery";

export const ContactApiSlice = createApi({
    reducerPath: "ContactApiSlice",
    baseQuery,

    tagTypes: ["contact"],

    endpoints: (builder) => ({

        contact: builder.mutation({
            query: (body) => ({
                url: 'contact',
                method: 'POST',
                body,
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["contact"]
        }),

    }),
});

export const {
    useContactMutation
} = ContactApiSlice; 